import type { Traducao } from '../tipos';

/** Textos de `estatisticas`. Preenchido pela tradução da área — ver ../README.md. */
export const estatisticas: Traducao = {
  pt: {
    cabecalho: {
      titulo: 'Estatísticas de Ativos',
      subtitulo: 'Visão geral e análise dos ativos cadastrados',
    },
    estado: {
      carregando: 'Carregando estatísticas...',
    },
    kpi: {
      totalAtivos: 'Total de Ativos',
      comApr: 'Com APR Tramitada',
      comAmt: 'Com AMT Tramitado',
      areasDiferentes: 'Áreas Diferentes',
    },
    porStatus: {
      titulo: 'Estatísticas por Status',
      subtitulo: 'Distribuição dos ativos por status',
    },
    porArea: {
      titulo: 'Top Áreas',
      subtitulo: 'Principais áreas com mais ativos',
      mostrando: 'Mostrando {{exibidos}} de {{total}} áreas',
    },
    porTipo: {
      titulo: 'Top Tipos',
      subtitulo: 'Principais tipos de equipamentos',
      mostrando: 'Mostrando {{exibidos}} de {{total}} tipos',
    },
  },
  en: {
    cabecalho: {
      titulo: 'Asset Statistics',
      subtitulo: 'Overview and analysis of the registered assets',
    },
    estado: {
      carregando: 'Loading statistics...',
    },
    kpi: {
      totalAtivos: 'Total Assets',
      comApr: 'With APR Submitted',
      comAmt: 'With AMT Submitted',
      areasDiferentes: 'Distinct Areas',
    },
    porStatus: {
      titulo: 'Statistics by Status',
      subtitulo: 'Asset distribution by status',
    },
    porArea: {
      titulo: 'Top Areas',
      subtitulo: 'Leading areas by number of assets',
      mostrando: 'Showing {{exibidos}} of {{total}} areas',
    },
    porTipo: {
      titulo: 'Top Types',
      subtitulo: 'Leading equipment types',
      mostrando: 'Showing {{exibidos}} of {{total}} types',
    },
  },
};
